import { render, staticRenderFns } from "./CheckedList.vue?vue&type=template&id=1edf1b8c&scoped=true&"
import script from "./CheckedList.vue?vue&type=script&lang=js&"
export * from "./CheckedList.vue?vue&type=script&lang=js&"
import style0 from "./CheckedList.vue?vue&type=style&index=0&id=1edf1b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edf1b8c",
  null
  
)

export default component.exports